"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationEnum = exports.LocaleEnum = exports.ListingGroupPurposeEnum = exports.ListingFilterDateRangeTypeEnum = exports.ListingFilterDateFlexibilityEnum = exports.ListingDiscountTypeEnum = exports.HeaderMenuPlacementEnum = exports.FooterMenuPlacementEnum = exports.BlogPlacementEnum = void 0;
var BlogPlacementEnum;
(function (BlogPlacementEnum) {
    /** Home owners */
    BlogPlacementEnum["HomeOwners"] = "home_owners";
    /** Latest news */
    BlogPlacementEnum["LatestNews"] = "latest_news";
    /** Travelling tips */
    BlogPlacementEnum["TravellingTips"] = "travelling_tips";
})(BlogPlacementEnum || (exports.BlogPlacementEnum = BlogPlacementEnum = {}));
var FooterMenuPlacementEnum;
(function (FooterMenuPlacementEnum) {
    FooterMenuPlacementEnum["Company"] = "company";
    FooterMenuPlacementEnum["Legal"] = "legal";
    FooterMenuPlacementEnum["Links"] = "links";
})(FooterMenuPlacementEnum || (exports.FooterMenuPlacementEnum = FooterMenuPlacementEnum = {}));
var HeaderMenuPlacementEnum;
(function (HeaderMenuPlacementEnum) {
    HeaderMenuPlacementEnum["Resources"] = "resources";
})(HeaderMenuPlacementEnum || (exports.HeaderMenuPlacementEnum = HeaderMenuPlacementEnum = {}));
var ListingDiscountTypeEnum;
(function (ListingDiscountTypeEnum) {
    /** Long stay discount */
    ListingDiscountTypeEnum["LongStay"] = "LONG_STAY";
    /** Monthly discount */
    ListingDiscountTypeEnum["Monthly"] = "MONTHLY";
    /** No discount */
    ListingDiscountTypeEnum["None"] = "NONE";
    /** Weekly discount */
    ListingDiscountTypeEnum["Weekly"] = "WEEKLY";
})(ListingDiscountTypeEnum || (exports.ListingDiscountTypeEnum = ListingDiscountTypeEnum = {}));
var ListingFilterDateFlexibilityEnum;
(function (ListingFilterDateFlexibilityEnum) {
    /** One day */
    ListingFilterDateFlexibilityEnum["OneDay"] = "ONE_DAY";
    /** Seven days */
    ListingFilterDateFlexibilityEnum["SevenDays"] = "SEVEN_DAYS";
    /** Three days */
    ListingFilterDateFlexibilityEnum["ThreeDays"] = "THREE_DAYS";
    /** Two days */
    ListingFilterDateFlexibilityEnum["TwoDays"] = "TWO_DAYS";
})(ListingFilterDateFlexibilityEnum || (exports.ListingFilterDateFlexibilityEnum = ListingFilterDateFlexibilityEnum = {}));
var ListingFilterDateRangeTypeEnum;
(function (ListingFilterDateRangeTypeEnum) {
    /** Selects the nearest available week. */
    ListingFilterDateRangeTypeEnum["AnyWeek"] = "ANY_WEEK";
    /** Filters by the exact start and end dates. */
    ListingFilterDateRangeTypeEnum["ExactDates"] = "EXACT_DATES";
})(ListingFilterDateRangeTypeEnum || (exports.ListingFilterDateRangeTypeEnum = ListingFilterDateRangeTypeEnum = {}));
var ListingGroupPurposeEnum;
(function (ListingGroupPurposeEnum) {
    /** Explore destinations */
    ListingGroupPurposeEnum["ExploreDestinations"] = "explore_destinations";
})(ListingGroupPurposeEnum || (exports.ListingGroupPurposeEnum = ListingGroupPurposeEnum = {}));
var LocaleEnum;
(function (LocaleEnum) {
    LocaleEnum["En"] = "en";
    LocaleEnum["Sv"] = "sv";
})(LocaleEnum || (exports.LocaleEnum = LocaleEnum = {}));
var LocationEnum;
(function (LocationEnum) {
    /** Country */
    LocationEnum["Country"] = "COUNTRY";
    /** City / Locality */
    LocationEnum["Locality"] = "LOCALITY";
    /** A place */
    LocationEnum["Place"] = "PLACE";
    /** Street name */
    LocationEnum["Street"] = "STREET";
})(LocationEnum || (exports.LocationEnum = LocationEnum = {}));
